(function () {
    'use strict';

    angular
        .module('riskEditModule')
        .controller('ViewHistoricOnRiskController', Controller);

    Controller.$inject = ['$scope', '$state', 'historicRecords'];

    function Controller($scope, $state, historicRecords) {

        $scope.historicRecords = historicRecords;
    }
})();